import $ from "jquery";
import "slick-carousel";


const testSlider = 'popup-test-slider';

$(`.${testSlider}`).slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  adaptiveHeight: true,
  arrows: false,
});



$('.button_popup').on('click', function() {
  // temporarily close all popups
  $('.popup').removeClass('is-active');
  $('.button__popup-content').addClass('hidden');

  // target the clicked popup
  const popup = $(this).find('.popup');

  // prepare the any sliders
  const sliderID = popup.data('slider');
  
  $(`.${sliderID}`).addClass('opacity-0');
  
  if (sliderID) {
    setTimeout(() => {
      $(`.${sliderID}`).slick("setPosition");
    }, 10);
  }

  // show popup
  popup.parents('.button__popup-content').removeClass('hidden');
  popup.addClass('is-active');
  if (sliderID) {
    $(`.${sliderID}`).removeClass('opacity-0');
  }

});

$('.close-popup').on('click', function(event) {
  event.stopPropagation();
  $(this).parents('.popup').removeClass('is-active')
  $(this).parents('.button__popup-content').addClass('hidden')
});

$('body').on('click', function() {
  $('.popup.is-active').removeClass('is-active');
  $('.popup.is-active').parents('.button__popup-content').addClass('hidden');
});

$('.button_popup').on('click', function(event) {
  event.stopPropagation();
});

